import { useContext } from "react";
import EditorStateContext from "./EditorStateContext";

export function useEditorState() {
    return useContext(EditorStateContext);
}
